module.exports = __webpack_public_path__ + "static/media/ex31.a8e400ad.mp3";